import { render, staticRenderFns } from "./AreaList.vue?vue&type=template&id=daa105ca&scoped=true&"
import script from "./AreaList.vue?vue&type=script&lang=js&"
export * from "./AreaList.vue?vue&type=script&lang=js&"
import style0 from "./AreaList.vue?vue&type=style&index=0&id=daa105ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa105ca",
  null
  
)

export default component.exports